import { render, staticRenderFns } from "./CellRendererDetailsCustomer.vue?vue&type=template&id=32056c25"
import script from "./CellRendererDetailsCustomer.vue?vue&type=script&lang=js"
export * from "./CellRendererDetailsCustomer.vue?vue&type=script&lang=js"
import style0 from "./CellRendererDetailsCustomer.vue?vue&type=style&index=0&id=32056c25&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports